import { createContext, useContext } from "react";

/** Use a context for the routing and therefore we are not tided into any specific technology, for example we can use react-router or query params */
export interface ISitemapRoutingContext {
    setSelectedSitemapId: (sitemapId: string | null) => void;
    getSelectedSitemapId: () => string;
    setSelectedSitemapVersionId: (sitemapVersionId: string | null) => void;
    getSelectedSitemapVersionId: () => string;
    setSelectedSitemapVersionLevelId: (sitemapVersionId: string | null) => void;
    getSelectedSitemapVersionLevelId: () => string;
}

export const SitemapRoutingContext = createContext<ISitemapRoutingContext | null>(null);

export const useSitemapRoutingContext = () => useContext(SitemapRoutingContext);
